import {
  GET_AUDIT_TICKETS_FAIL,
  GET_AUDIT_TICKETS_SUCCESS,
  GET_EXPORTED_AUDIT_TICKETS_FAIL,
  GET_EXPORT_AUDIT_TICKETS_SUCCESS,
  RESET_EXPORT_DATA,
  CLEAR_MESSAGE,
} from "./actionTypes"

const INIT_STATE = {
  auditTicketList: [],
  error: {},
  message: "",
  pagination: {},
  search: "",
  file: "",
}

const auditTicket = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_AUDIT_TICKETS_SUCCESS:
      return {
        ...state,
        auditTicketList: action.payload?.data,
        pagination: action.payload?.pagination || {},
      }

    case GET_AUDIT_TICKETS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_EXPORT_AUDIT_TICKETS_SUCCESS:
      return {
        ...state,
        message: action.payload?.message,
        file: action.payload?.file,
        error: {},
      }

    case GET_EXPORTED_AUDIT_TICKETS_FAIL:
      return {
        ...state,
        file: "",
        error: action.payload?.message || "Error occurred in export file.",
      }

    case RESET_EXPORT_DATA:
      return {
        ...state,
        error: {},
        message: "",
        file: "",
      }

    case CLEAR_MESSAGE:
      return {
        ...state,
        error: {},
        message: "",
      }

    default:
      return state
  }
}

export default auditTicket
